import { useState } from 'react';

import { colmarLogoBase64 } from 'assets/colmarLogoBase64';

import * as S from './Image.styles';
import { StyledImageProps } from './Image.styles';

type ImageProps = {
  source: string;
  alt: string;
  className?: string;
  children?: React.ReactNode;
} & StyledImageProps;

export function Image(props: ImageProps): React.ReactElement {
  const {
    source,
    alt,
    className = undefined,
    children = undefined,
    opacity = '1',
    asAutoSize = false,
    isBudget = false,
  } = props;
  const [error, setShowError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const showPlaceholder = !source || error || !loaded;

  return (
    <S.Wrapper className={className} asAutoSize={asAutoSize} isBudget={isBudget}>
      {showPlaceholder && (
        <S.Image
          opacity={opacity}
          src={colmarLogoBase64}
          alt=""
          aria-hidden="true"
          className="error-image"
          isBudget={isBudget}
        />
      )}
      {source && !error && (
        <S.Image
          opacity={opacity}
          src={source}
          alt={alt}
          onError={() => setShowError(true)}
          afterLoad={() => setLoaded(true)}
        />
      )}

      {children || null}
    </S.Wrapper>
  );
}
